interface OutsideClickBinding {
  // список css селекторов, которые должны игнорировать missClick
  ignoreElements: string[]
  // обработчик миссклика
  handler: void
}

/**
 * принимает объект MissClickBinding
 *
 */

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('outside-click', {
    mounted(_el, binding) {
      if (binding.value) {
        const { ignoreElements, handler }: OutsideClickBinding = binding.value

        window.addEventListener(
          'click',
          (outsideClickHandler as any).bind(null, ignoreElements, handler),
        )
      }
    },
    unmounted(_el, binding) {
      if (binding.value) {
        window.removeEventListener('click', outsideClickHandler as any)
      }
    },
  })
})

/**
 * обрабатывает missClick по элементу
 * @param ignoreElements - список css селекторов, которые должны игнорировать missClick
 * @param handler - обработчик миссклика
 * @param event - событие клика
 */

// TODO: Привести к MouseEvent или типизировать иначе
const outsideClickHandler = (
  ignoreElements: string[],
  handler: any,
  event: { target: Element },
) => {
  const { target } = event

  const missClickElements = []

  ignoreElements.forEach((element: string) => {
    if (target.closest(element)) missClickElements.push(element)
  })

  if (!missClickElements.length) {
    handler()
  }
}
